 


<div class="banner d-none d-md-flex flex-row align-items-center  justify-content-center ">
  <div class="container-lg d-flex flex-row align-items-center justify-content-end" ngbNav #nav="ngbNav" role="navigation">
    <button class="btn btn-primary btn-sm" ngbNavItem  (click)="navigateToHome()"  >{{'verbiage.banner.home.title' | transloco }}</button>
    <button class="btn btn-primary btn-sm" ngbNavItem  (click)="changeLanguage()">{{'verbiage.banner.language.title' | transloco }}</button>
    <button class="btn btn-primary btn-sm" ngbNavItem  (click)="goToLanguangeHelp()"  >{{'verbiage.banner.languageHelp.title' | transloco }}</button>
    <div class="menu-container nav-item"  ngbNavItem  ngbDropdown >
      <button class="btn btn-primary btn-sm " ngbDropdownToggle   >{{'verbiage.banner.customerSupport.title' | transloco }}</button>
      <ul class="menu-content" role="menu" ngbDropdownMenu >
        <li>
      <a tabindex="0" role="menuitem" class="menu-item" 
      ngbDropdownItem [href]="'verbiage.banner.customerSupport.hotline.url' | transloco" >{{'verbiage.banner.customerSupport.hotline.title' | transloco }}</a>
      <div class="dropdown-divider"></div>
      </li>
      <li>
      <a tabindex="0" role="menuitem" class="menu-item" ngbDropdownItem [href]="'verbiage.banner.customerSupport.hotline_text.url' | transloco" >{{'verbiage.banner.customerSupport.hotline_text.title' | transloco }}</a>
      <div class="dropdown-divider"></div>
      </li>
      <li>
      <a tabindex="0" role="menuitem" class="menu-item" ngbDropdownItem [href]="'verbiage.banner.customerSupport.navigator.url' | transloco: {baseDomain: redirectDomain$$()}" 
      [attr.aria-label]="('verbiage.banner.customerSupport.navigator.title' | transloco) + ' ' + ('verbiage.footer.opensNewWindow' | transloco)"
      target="_blank">{{'verbiage.banner.customerSupport.navigator.title' | transloco }}</a>
      <div class="dropdown-divider"></div>
      </li>
      <li>
      <a tabindex="0" role="menuitem" class="menu-item" ngbDropdownItem [href]="'verbiage.banner.customerSupport.broker.url' | transloco: {baseDomain: redirectDomain$$()}" 
      [attr.aria-label]="('verbiage.banner.customerSupport.broker.title' | transloco) + ' ' + ('verbiage.footer.opensNewWindow' | transloco)"
      target="_blank">{{'verbiage.banner.customerSupport.broker.title' | transloco }}</a>
      <div class="dropdown-divider"></div>
      </li>
      <li>
      <a tabindex="0" role="menuitem" class="menu-item" ngbDropdownItem [href]="'verbiage.banner.customerSupport.language.url' | transloco: {baseDomain: redirectDomain$$()}" 
      [attr.aria-label]="('verbiage.banner.customerSupport.language.title' | transloco) + ' ' + ('verbiage.footer.opensNewWindow' | transloco)"
      target="_blank">{{'verbiage.banner.customerSupport.language.title' | transloco }}</a>
      <div class="dropdown-divider"></div>
      </li>
      <li>
      <a tabindex="0" role="menuitem" class="menu-item" ngbDropdownItem [href]="'verbiage.banner.customerSupport.glossary.url' | transloco" 
      [attr.aria-label]="('verbiage.banner.customerSupport.glossary.title' | transloco) + ' ' + ('verbiage.footer.opensNewWindow' | transloco)"
      target="_blank">{{'verbiage.banner.customerSupport.glossary.title' | transloco }}</a>
    </li>  
    </ul>
    </div>
    
  </div>
</div>
<!-- for small screens uses hamburger menu -->
<div class="banner-md pt-2 d-flex d-md-none">
  <div class="container-lg d-flex d-md-none flex-row align-items-center justify-content-between gap-3" role="navigation">
    
    <div class="logo-container-md">
      <a [href]="'verbiage.banner.home.url' | transloco: {baseDomain: redirectDomain$$()}">
        <img alt="Washington health plan finder logo" [src]="'logo.png'" />
      </a>
    </div>
    <div class="menu-container" (focusout)="onHamburgerMenuFocusOut($event)">
      <button class="btn btn-primary menu-toggle" role="button" aria-label="menu" aria-controls="mobile-nav-menu" [attr.aria-expanded]="showHamburgerMenu" [ngClass]="{'active': showHamburgerMenu}" (click)="toggleHamburgerMenu()">

        <span class="icon-bar top-bar"></span>
        <span class="icon-bar middle-bar"></span>
        <span class="icon-bar bottom-bar"></span>


      </button>

      <div id="mobile-nav-menu" class="menu-content-md" [ngClass]="{'active': showHamburgerMenu}">
        @if (showDashboardLink$$()) {
          <a role="menuitem" class="menu-item" [href]="'verbiage.banner.home.url' | transloco: {baseDomain: redirectDomain$$()}">{{ 'verbiage.banner.dashboard.title' | transloco }}</a>
          <hr>
        }
        <a role="menuitem" class="menu-item" href="#" (click)="$event.preventDefault(); changeLanguage()">{{'verbiage.banner.language.title' | transloco }}</a>
        <hr>
        <p>{{'verbiage.banner.customerSupport.title' | transloco }}</p>
        <a role="menuitem" class="menu-item" [href]="'verbiage.banner.customerSupport.hotline.url' | transloco" >{{'verbiage.banner.customerSupport.hotline.title' | transloco }}</a>
        <a role="menuitem" class="menu-item" [href]="'verbiage.banner.customerSupport.hotline_text.url' | transloco" >{{'verbiage.banner.customerSupport.hotline_text.title' | transloco }}</a>
        <hr>
        <a role="menuitem" class="menu-item" [href]="'verbiage.banner.languageHelp.url' | transloco: {baseDomain: redirectDomain$$()}" 
           [attr.aria-label]="('verbiage.banner.languageHelp.title' | transloco) + ' ' + ('verbiage.footer.opensNewWindow' | transloco)"
           target="_blank">{{'verbiage.banner.languageHelp.title' | transloco }}</a>
        <hr>
        <a role="menuitem" class="menu-item" [href]="'verbiage.banner.customerSupport.navigator.url' | transloco: {baseDomain: redirectDomain$$()}" 
           [attr.aria-label]="('verbiage.banner.customerSupport.navigator.title' | transloco) + ' ' + ('verbiage.footer.opensNewWindow' | transloco)"
           target="_blank">{{'verbiage.banner.customerSupport.navigator.title' | transloco }}</a>
        <hr>
        <a role="menuitem" class="menu-item" [href]="'verbiage.banner.customerSupport.broker.url' | transloco: {baseDomain: redirectDomain$$()}" 
           [attr.aria-label]="('verbiage.banner.customerSupport.broker.title' | transloco) + ' ' + ('verbiage.footer.opensNewWindow' | transloco)"
          target="_blank">{{'verbiage.banner.customerSupport.broker.title' | transloco }}</a>
        <hr>
        <a role="menuitem" class="menu-item" [href]="'verbiage.banner.customerSupport.language.url' | transloco: {baseDomain: redirectDomain$$()}" 
           [attr.aria-label]="('verbiage.banner.customerSupport.language.title' | transloco) + ' ' + ('verbiage.footer.opensNewWindow' | transloco)"
           target="_blank">{{'verbiage.banner.customerSupport.language.title' | transloco }}</a>
        <hr>
        <a role="menuitem" class="menu-item" [href]="'verbiage.banner.customerSupport.glossary.url' | transloco" 
           [attr.aria-label]="('verbiage.banner.customerSupport.glossary.title' | transloco) + ' ' + ('verbiage.footer.opensNewWindow' | transloco)"
           target="_blank">{{'verbiage.banner.customerSupport.glossary.title' | transloco }}</a>
    </div>
    </div>
  </div>
  
</div>

<div class="container-lg d-none d-md-flex align-items-center justify-content-between">

    <div class="logo-container me-2">
      <a [href]="'verbiage.banner.home.url' | transloco: {baseDomain: redirectDomain$$()}">
        <img alt="Washington health plan finder logo"  [src]="'logo.png'" />
      </a>
    </div>

    @if (showDashboardLink$$()) {
      <a class="dashboard-link" [href]="'verbiage.banner.dashboard.url' | transloco: {baseDomain: dashboardDomain$$()}">
        <i class="fa-solid fa-circle-user" aria-hidden="true"></i>
        {{ 'verbiage.banner.dashboard.title' | transloco }}
      </a>
    }
</div>